import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { StorageGet, StorageSet } from '@mdd/api';
import { GetLastLogin } from '../../domain/interactors/account';
import { PrincipalService } from '../principal.service';

const RELOGIN_TIME = 'reloginTime';
const RELOGIN_PARAM = /^(.*\?)(?:|.*&)(relogin(?:$|&|=[^&]*(?:$|&)))(.*)$/;

@Injectable()
export class ReloginGuard {
    private storageGet = new StorageGet<number | null>();
    private storageSet = new StorageSet<number | null>();
    private getLastLogin = new GetLastLogin();

    constructor(
        protected location: Location,
        protected principal: PrincipalService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canLoad();
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    canLoad(): boolean {
        // Do they need to relogin?
        const reloginTime = this.storageGet.execute(RELOGIN_TIME);
        const lastLoginTime = this.getLastLogin.execute();
        if (reloginTime && reloginTime < lastLoginTime) {
            // If previously set reloginTime is less than the last login time, the
            // user has signed in again
            this.storageSet.execute({
                key: RELOGIN_TIME,
                value: null
            });

            return true;
        } else if (RELOGIN_PARAM.test(this.location.path())) {
            // Session must be logged out and logged in again
            this.storageSet.execute({
                key: RELOGIN_TIME,
                value: Date.now()
            });

            // Logout will navigate to /login
            this.principal.logout({
                return: this.location.path().replace(RELOGIN_PARAM, '$1$3'),
                relogin: true
            });

            return false;
        } else {
            return true;
        }
    }
}
